export default {
  channelDataManeuvering: null,
  channelDataEngine: null,
  channelDataAlert: null,
  abnormalMachinery: [],
  initializedSeaRoute: false,
  seaRoutes: null,
  veeringPoints: null,
  passingPoints: null,
  isArrivedPoint: false,
  isLessThan1kn: false,
  eventData: null,
  isBerthMode: false,
  arrivalPoint: null,
  latestDeparturePoint: null,
  nextArrivalPoint: null,
  otherVesselsPosition: [],
  otherVesselsInfo: null,
  trackPositions: [],
  trackHistories: null,
  ghostPositions: [],
  vesselInfo: null,
  jumpTo: null,
  connectingState4gVSAT: null,
  connectingStateSBX: null,
  connectingStateAMS: null,
  initialFOFlowData: null,
  foFlows: {
    starboardFOFlow1: -1,
    portFOFlow1: -1,
    starboardFOFlow2: -1,
    portFOFlow2: -1
  },
  foFlowsSum: -1,
  estimateFOFlow: [],
  unsubscribes: [],
  // 仮想岸壁
  virtualQuayPositions: [
    [
      [139.6794285, 35.2845477],
      [139.6780015, 35.2808077]
    ],
    [
      [130.9934759, 33.8777636],
      [130.9935619, 33.8751696]
    ]
  ],
  isPositionsUpdatingByApi: false,
  beforeUpdatingGhostByApiDatetime: null,
  engineDataFirstFetchFromFirebase: true,
  maneuveringDataFirstFetchFromFirebase: true,
};
